import { z } from 'src/lib'
import { DetalleFields } from './detalle-fields'
import { getEndpoint } from './httpWRC'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { EntityWithIdFields } from 'src/types'

const detalle = z
    .object({
        [DetalleFields.DescripcionOperacionTipo]: z.string(),
        [DetalleFields.DescripcionOperacionExcepcion]: z.string(),
        [DetalleFields.DescripcionExcepcion]: z.string(),
        [DetalleFields.IdOperacion]: z.number()
    })
    .extend({
        [EntityWithIdFields.Id]: z.number()
    })

const schema = z.array(detalle)

export type Detalle = z.infer<typeof detalle>
export type Detalles = z.infer<typeof schema>

export const getDetalles = (idOperacion: number): Promise<Detalles> => {
    const endpoint = getEndpoint(`${idOperacion}/detalles`)

    return HttpAxiosRequest.get(endpoint)
        .then(response => {
            const parsed = schema.safeParse(response)

            if (!parsed.success) {
                console.error(parsed.error.issues)

                return Promise.reject('Error de validación.')
            }

            return parsed.data // TODO: tiene q ser promise
        })
        .catch(error => {
            console.error(error)

            return Promise.reject('Error de red.')
        })
}
